import React, { useState } from "react";
import Body from "./Body";
import AllotmentStore from "../../../../store/Operational/Residential/Allotment.store";
const Allotment = () => {
  const [filter, setFilter] = useState({
    gender: "all",
  });
  const [classesFilter, setClassesFilter] = useState([]);

  const [changeDetails, setChangeDetails] = useState(false); //change allotment details modal status
  const [allotmentHistory, setAllotmentHistory] = useState(false); //it is used for  show the previous allotment history of a staff/student
  const [deleteAllotmentState, setDeleteAllotmentState] = useState(false);
  const handelDeleteAllotment = (e, _id) => {
    if (!deleteAllotmentState) {
      e.target.parentNode.classList.add("activeAllotmentDeleteBtn");
      console.log(
        e.target.parentNode.nextElementSibling.setAttribute(
          "style",
          "display:none;"
        )
      );
      setDeleteAllotmentState(true);
    } else {
      e.target.parentNode.classList.remove("activeAllotmentDeleteBtn");
      e.target.parentNode.nextElementSibling.removeAttribute("style");
      setDeleteAllotmentState(false);
    }
  };
  const handelEditAllotment = (e, _id) => {
    console.log(_id);
  };
  const deleteAllotment = () => {
    console.log("Delete the allotment");
  };

  const { allotmentId, setlAllotmentId } = AllotmentStore();
  const _this = {
    filter,
    setFilter,
    classesFilter,
    setClassesFilter,
    changeDetails,
    setChangeDetails,
    handelDeleteAllotment, //function fot handel delete allotment
    handelEditAllotment, //function fot handel edit allotment
    deleteAllotment,
    deleteAllotmentState,
    allotmentHistory,
    setAllotmentHistory,
    //store states
    allotmentId,
    setlAllotmentId,
  };
  return <Body {..._this} />;
};

export default Allotment;
